/**
 * Provider factory: PAYMENT_MODE → PaymentProvider.
 *
 * 'disabled' is the only mode with an implementation. 'test' and 'live' throw
 * here, at startup, rather than returning a provider that could confirm
 * anything: until the Worker-side PAYUNi flow exists there is no code path
 * that may mark a payment CONFIRMED except the explicit disabled bypass.
 */

import { DisabledPaymentProvider } from './disabled';
import type { PaymentMode, PaymentProvider } from './types';

export class PaymentModeUnavailableError extends Error {
  readonly mode: PaymentMode;
  constructor(mode: PaymentMode) {
    super(`PAYMENT_MODE "${mode}" is not implemented: the PAYUNi flow (Worker createOrder → PAYUNi → callback → Worker verification → entitlement) is not wired yet`);
    this.name = 'PaymentModeUnavailableError';
    this.mode = mode;
  }
}

export function createPaymentProvider(mode: PaymentMode): PaymentProvider {
  switch (mode) {
    case 'disabled':
      return new DisabledPaymentProvider();
    case 'test':
    case 'live':
      throw new PaymentModeUnavailableError(mode);
    default: {
      const never: never = mode;
      throw new Error(`unknown PAYMENT_MODE ${String(never)}`);
    }
  }
}
